'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dCredential from "./presto.types$proto$-Sites-By-Credential.js";
import * as $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dCredential$002dGroup from "./presto.types$proto$-Sites-By-Credential-Group.js";
import * as $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dTfa from "./presto.types$proto$-Sites-By-Tfa.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$41() {
}
export { $c_Lpresto_SitesView$$anon$41 as $c_Lpresto_SitesView$$anon$41 };
$p = $c_Lpresto_SitesView$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$41;
/** @constructor */
function $h_Lpresto_SitesView$$anon$41() {
}
export { $h_Lpresto_SitesView$$anon$41 as $h_Lpresto_SitesView$$anon$41 };
$h_Lpresto_SitesView$$anon$41.prototype = $p;
$p.cMA = (function(x$0) {
  if ((x$0 instanceof $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dCredential.$c_Lpresto_types$proto$SitesByCredential)) {
    return 0;
  }
  if ((x$0 instanceof $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dTfa.$c_Lpresto_types$proto$SitesByTfa)) {
    return 1;
  }
  if ((x$0 instanceof $j_presto$002etypes$0024proto$0024$002dSites$002dBy$002dCredential$002dGroup.$c_Lpresto_types$proto$SitesByCredentialGroup)) {
    return 2;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_SitesView$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$41, "presto.SitesView$$anon$41", ({
  RI: 1,
  a: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_SitesView$$anon$41 as $d_Lpresto_SitesView$$anon$41 };
//# sourceMappingURL=presto.-Sites-View$$anon$41.js.map
